/**
 * Vivofácil — galería de producto sin elevateZoom (hover lupa).
 * Miniaturas + lightbox Fancybox al hacer clic en la imagen principal.
 */
(function ($) {
  'use strict';

  function cleanupElevateZoom() {
    var $img = $('#product-featured-image');
    if (!$img.length) return;

    var ez = $img.data('elevateZoom');
    if (ez && typeof ez.destroy === 'function') {
      try {
        ez.destroy();
      } catch (err) {}
    }
    $img.removeData('elevateZoom');

    if ($img.parent('.zoomWrapper').length) {
      $img.unwrap();
    }

    $('.zoomContainer').remove();

    $img.css({
      position: '',
      width: '',
      height: '',
      left: '',
      top: '',
      transform: '',
    });
  }

  function buildLightboxItems($featured) {
    var items = [];
    var startIndex = 0;

    $('#ProductThumbs li:not(.video-external) > a[data-image], #ProductThumbs li:not(.video-external) > button[data-image]').each(function () {
      var $a = $(this);
      var href = $a.attr('data-zoom-image') || $a.attr('data-image');
      if (!href) return;

      items.push({
        href: href,
        title: $a.find('img').attr('alt') || '',
      });

      if ($a.closest('li').hasClass('active')) {
        startIndex = items.length - 1;
      }
    });

    if (!items.length) {
      items.push({
        href: $featured.attr('data-zoom-image') || $featured.attr('src'),
        title: $featured.attr('alt') || '',
      });
    }

    return { items: items, startIndex: startIndex };
  }

  function openLightbox(ev) {
    ev.preventDefault();
    var $featured = $('#product-featured-image');
    if (!$featured.length || !$.fancybox) return false;

    var gallery = buildLightboxItems($featured);
    $.fancybox(gallery.items, {
      index: gallery.startIndex,
      padding: 12,
      titleShow: true,
      overlayShow: true,
      hideOnContentClick: true,
    });
    return false;
  }

  function initProductGallery() {
    if (!$('.product-single').length) return;

    cleanupElevateZoom();

    var $featured = $('#product-featured-image');
    if (!$featured.length) return;

    /* Owl Carousel anida li dentro de .owl-item; no usar hijo directo (>) */
    var thumbSelector = '#ProductThumbs li:not(.video-external) > a[data-image], #ProductThumbs li:not(.video-external) > button[data-image]';

    $(document).off('click.vfGallery', thumbSelector);
    $(document).on('click.vfGallery', thumbSelector, function (ev) {
      var $a = $(this);

      ev.preventDefault();
      ev.stopPropagation();

      var newImage = $a.attr('data-image');
      var zoomImage = $a.attr('data-zoom-image') || newImage;
      if (!newImage) return;

      cleanupElevateZoom();
      $featured.attr('src', newImage).attr('data-zoom-image', zoomImage).show();
      $('.product-video-container').hide();
      $('#ProductThumbs li').removeClass('active');
      $a.closest('li').addClass('active');
    });

    if (!$('#ProductThumbs li.active').length) {
      $('#ProductThumbs li:first').addClass('active');
    }

    var $link = $featured.closest('a');
    if ($link.length) {
      $link.off('click.vfLightbox').on('click.vfLightbox', openLightbox);
    } else {
      $featured.off('click.vfLightbox').on('click.vfLightbox', openLightbox);
    }
  }

  $(function () {
    initProductGallery();
    /* shop.js inicializa Owl Carousel después; re-enlazar por si el DOM cambió */
    setTimeout(initProductGallery, 400);
  });
})(jQuery);
